// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__eyhGa","textarea":"TextArea_textarea__BBQE-"};